import { FetchUserIdentificationsRoutine } from '../routines';

export const initialState = {
  isFetching: false,
  data: {},
  error: null
};

export const userIdentificationsReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FetchUserIdentificationsRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null
      };
    case FetchUserIdentificationsRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case FetchUserIdentificationsRoutine.FAILURE:
      return {
        ...state,
        data: {},
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};
